import React from 'react';
import ColorsMain from '../../colors/ColorsMain'

const TextArea = ({ value, onChange, placeholder, subtitleLeft, subtitleRight, href, error = false, readOnly }) => {

  return (

    <div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full h-32 p-4 border rounded-lg border-[#5E5E63] bg-[#26262D] text-[#FFFFFF] 
        font-dm-sans text-lg leading-[130%] tracking-[-0.16px] outline-none 
        resize-none placeholder:text-gray-500 transition-colors duration-300 ease-in-out"
        style={{
          fontSize: 16,
          borderColor: error ? ColorsMain.errorBorder : ColorsMain.borderInput
        }}
        readOnly={readOnly}
      />

      <div className='flex justify-between' >
        <p className='text-[#B7B7B9] text-xs '>{subtitleLeft}</p>

      </div>

    </div>

  );
};

export default TextArea;


/* como se usa

const [text, setText] = useState('');

  return (
    <div className="p-8">
      <TextArea
        value={text}
        subtitle={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Escribe aquí tu texto..."
      />
    </div>
  );
};*/